module.exports = __webpack_public_path__ + "static/media/elvis_img_transparent.35247df1.png";